import glamorous from 'glamorous'

export const SecondaryButton = glamorous.button({
    background: 'none',
    outline: 'none',
    border: 'none',
    backgroundColor: '#000',
    borderRadius: '9px'
})